import { AlertTriangle, Mail, Phone } from "lucide-react";
import ContentLoader from "../authentication/ContentLoader";
import { SidebarProvider } from "@/components/ui/sidebar";
import Teacherheader from "./Teacherheader";
import Teachersidebar from "./Teachersidebar";

interface SuspensionWarningProps {
  schoolName?: string;
  isLoading?: boolean;
}

// Standalone suspension warning (for use within pages)
const SuspensionWarningContent = ({ schoolName = "this school" }: { schoolName?: string }) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh] p-4">
      <div className="max-w-lg w-full bg-gradient-to-br from-red-50 to-orange-50 dark:from-red-950/30 dark:to-orange-950/30 border border-red-200 dark:border-red-800 rounded-2xl shadow-xl p-8">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-red-100 dark:bg-red-900/50 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="h-8 w-8 text-red-600 dark:text-red-400" />
          </div>
          <h2 className="text-2xl font-bold text-red-700 dark:text-red-400 mb-2">
            Access Temporarily Suspended
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            Your access to <span className="font-semibold text-red-600 dark:text-red-400">{schoolName}</span> has been temporarily revoked by the school administrator.
          </p>
          <div className="w-full bg-white dark:bg-gray-800 rounded-xl p-4 mb-6">
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
              To regain access, please contact the school administration:
            </p>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                <Mail className="h-4 w-4 text-blue-500" />
                <span className="text-sm">Contact your school admin via email</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                <Phone className="h-4 w-4 text-green-500" />
                <span className="text-sm">Or call the school office</span>
              </div>
            </div>
          </div>
          <p className="text-xs text-gray-400 dark:text-gray-500">
            If you believe this is an error, please reach out to the school administration immediately.
          </p>
        </div>
      </div>
    </div>
  );
};

// Full page suspension warning with layout (for standalone pages)
const SuspensionWarning = ({ schoolName = "this school", isLoading = false }: SuspensionWarningProps) => {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-50 dark:bg-gray-900">
        <Teachersidebar />
        <div className="flex flex-col flex-1">
          <Teacherheader />
          <main className="flex-grow p-3 sm:p-6 bg-gray-50 dark:bg-gray-900 h-full">
            <ContentLoader isLoading={isLoading} message="">
              <SuspensionWarningContent schoolName={schoolName} />
            </ContentLoader>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export { SuspensionWarningContent };
export default SuspensionWarning;
